export default __webpack_public_path__ + "static/media/persona2.06605b82.jpg";